import React from "react";
import { Link } from "react-router-dom";
import './Footer.css';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import FacebookIcon from '@mui/icons-material/Facebook';
import InstagramIcon from '@mui/icons-material/Instagram';
import XIcon from '@mui/icons-material/X';

const Footer = () => {
  const socialLinks = [
    { icon: <WhatsAppIcon />, name: "WhatsApp", path: "https://api.whatsapp.com/send?phone=8812233466", color: "#25D366" },
    { icon: <FacebookIcon />, name: "Facebook", path: "https://www.facebook.com/people/DBasesolutionspvtltd/61560310641678/", color: "#1877F2" },
    { icon: <InstagramIcon />, name: "Instagram", path: "https://www.instagram.com/dbasesolutionspvtltd/", color: "#E4405F" },
    { icon: <XIcon />, name: "X", path: "https://x.com/DbsPvtItd?t=dxL2jNKK8f-1vPHwoym7zA&s=09", color: "#000000" },
  ];

  return (
    <footer className="dbs-footer-wrapper">
      <div className="dbs-footer-bg-glow"></div>

      {/* Dynamic World Map Background */}
      <div className="dbs-footer-map-container">
        <div className="dbs-footer-map-overlay"></div>
        <div className="dbs-footer-location-pin" title="Eluru, India">
          <div className="dbs-footer-pin-pulse"></div>
          {/* <div className="dbs-footer-pin-icon">📍</div> */}
        </div>
      </div>

      <div className="dbs-footer-container">
        <div className="dbs-footer-main-content">
          {/* Brand/About Section */}
          <div className="dbs-footer-section dbs-footer-brand">
            <img src="./images/dbase.png" alt="DBS Logo" className="dbs-footer-logo" />
            <p className="dbs-footer-text">
              D Base Solutions Private Limited (DBS) was founded in 2011 by IT industry experts with a vision to provide feasible and cost-effective IT solutions to enterprises. Based in Eluru, Eluru District, Andhra Pradesh, India, DBS has established itself as a front-runner in IT services, recognized for exceptional service capabilities and industry-leading solutions.
            </p>
            <div className="dbs-footer-social-strip">
              {socialLinks.map((link, index) => (
                <a
                  key={index}
                  href={link.path}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="dbs-footer-social-icon-btn"
                  title={link.name}
                  style={{ '--hover-color': link.color }}
                >
                  {link.icon}
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links Section */}
          <div className="dbs-footer-section dbs-footer-nav">
            <h3 className="dbs-footer-subheading">Navigation</h3>
            <ul className="dbs-footer-list">
              <li><Link to="/">Home</Link></li>
              <li><Link to="/about">About Us</Link></li>
              <li><Link to="/products">Products</Link></li>
              <li><Link to="/clientele">Clientele</Link></li>
              <li><Link to="/careers">Careers</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="dbs-footer-section dbs-footer-contact">
            <h3 className="dbs-footer-subheading">Get In Touch</h3>
            <div className="dbs-footer-contact-item">
              <span className="dbs-footer-location-tag">Eluru:</span>
              <p className="dbs-footer-text">D.No: 16-58/33, Sai Sadan, Hanuman Nagar, Eluru, AP-534001, India</p>
            </div>
            <div className="dbs-footer-contact-item">
              <span className="dbs-footer-location-tag">Vijayawada:</span>
              <p className="dbs-footer-text">D.No: 12-22, First Floor, Behind Alankar Bakery, Enikepadu, Vijayawada - 521108</p>
            </div>
            <div className="dbs-footer-contact-item">
              <span className="dbs-footer-contact-label">Phone & Email:</span>
              <p className="dbs-footer-text">+91 93943 22302 | info@dbasesolutions.in | hr@dbasesolutions.in</p>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="dbs-footer-bottom">
          <div className="dbs-footer-divider"></div>
          <div className="dbs-footer-bottom-inner">
            <p className="dbs-footer-copyright">
              © {new Date().getFullYear()} <span className="dbs-highlight">D Base Solutions Pvt Ltd</span>. All Rights Reserved.
            </p>
            <div className="dbs-footer-legal">
              <Link to="/privacy-policy">Privacy Policy</Link>
              <Link to="/terms-and-conditions">Terms of Service</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
